import type { Region } from "./region";

const LOCALES: Record<Region, string> = {
  ie: "en-IE",
  uk: "en-GB",
};

const CURRENCIES: Record<Region, string> = {
  ie: "EUR",
  uk: "GBP",
};

const FREE_AS_ZERO_CATEGORIES = new Set<string>([
  "additional_testing",
  "additional_services",
  "consultation_fees",
]);

export function isFreePrice(
  raw: string | number | undefined,
  category: string | undefined,
): boolean {
  if (!category || !FREE_AS_ZERO_CATEGORIES.has(category)) return false;
  if (raw === undefined || raw === null || raw === "") return false;
  return Number(raw) === 0;
}

export function formatPrice(
  value: string | number | undefined,
  region: Region,
): string | undefined {
  if (value === undefined || value === null || value === "") return undefined;
  const raw = typeof value === "string" ? value.trim() : String(value);
  const n = Number(raw);
  if (!Number.isFinite(n)) return raw;
  const hasDecimals = /\.\d*[1-9]/.test(raw);
  return new Intl.NumberFormat(LOCALES[region], {
    style: "currency",
    currency: CURRENCIES[region],
    minimumFractionDigits: hasDecimals ? 2 : 0,
    maximumFractionDigits: 2,
  }).format(n);
}
